import React, { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '../../components/ui/primitives/Dialog';

interface StudioAiBuildDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  activityLabel?: string;
  subjectLabel?: string;
  /** Si false, falta contexto de asignatura (no se permite generación genérica). */
  subjectReady?: boolean;
  loading?: boolean;
  onConfirm: (prompt: string) => void;
}

export function StudioAiBuildDialog({
  open,
  onOpenChange,
  activityLabel = 'actividad',
  subjectLabel,
  subjectReady = true,
  loading = false,
  onConfirm,
}: StudioAiBuildDialogProps) {
  const [prompt, setPrompt] = useState('');

  const handleConfirm = () => {
    const trimmed = prompt.trim();
    if (!trimmed || !subjectReady) return;
    onConfirm(trimmed);
    setPrompt('');
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sala-dialog--studio sala-dialog--ai">
        <DialogHeader>
          <DialogTitle>Construir con IA</DialogTitle>
          <DialogDescription>
            {subjectReady && subjectLabel ? (
              <>
                Estás en <strong>{subjectLabel}</strong>. Describe la {activityLabel} — la IA usará la
                directiva pedagógica de la asignatura.
              </>
            ) : subjectReady ? (
              <>
                Describe la {activityLabel}. La IA aplicará el contexto pedagógico de tu asignatura.
              </>
            ) : (
              <>
                La generación con IA requiere abrir esta actividad desde una asignatura del Studio (no desde
                herramientas libres).
              </>
            )}
          </DialogDescription>
        </DialogHeader>
        <div className="sala-dialog__body">
          <textarea
            className="sala-input-dark min-h-[8rem] w-full resize-y text-sm"
            value={prompt}
            onChange={(e) => setPrompt(e.target.value)}
            placeholder={
              subjectReady
                ? 'Ej: Secuencia de 10 pasos sobre el Imperio Romano, desde la fundación hasta la caída…'
                : 'Vuelve al Studio, elige tu asignatura y crea la actividad desde ahí.'
            }
            autoFocus={subjectReady}
            disabled={!subjectReady || loading}
          />
          {subjectReady && (
            <p className="mt-2 text-[10px] leading-relaxed text-slate-400">
              Mismo motor Subject-Aware que las recetas del Studio: nivel de rigor acorde a la materia.
            </p>
          )}
        </div>
        <DialogFooter>
          <button type="button" className="sala-btn-outline text-xs" onClick={() => onOpenChange(false)} disabled={loading}>
            Cancelar
          </button>
          <button
            type="button"
            className="sala-btn-hero text-xs"
            disabled={!prompt.trim() || !subjectReady || loading}
            onClick={handleConfirm}
          >
            {loading ? 'Generando…' : 'Confirmar propuesta'}
          </button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
